

export class DesignationStatusInput implements IDesignationStatusInput {
    /** The auto-generated id of the designation master */
    designationId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IDesignationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designationId = _data["designationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DesignationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationId"] = this.designationId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDesignationStatusInput {
    /** The auto-generated id of the designation master */
    designationId: number;
    /** The updated status */
    status: number;
}

